import { Suspense } from "react";

import { logger, TanStackProvider } from "@bn-monorepo/js-packages";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";
import { SettingsInterface } from "./settingsContext";
import SettingsProvider from "./SettingsProvider";

logger.attachLoggerToOnErrorEvent();

export interface InitialPageData {
  header: any;
  pageContent: any;
  footer: any;
}

export interface SpaInitObject {
  settings: SettingsInterface;
  initialPageData: InitialPageData;
}
const container = document.getElementById("root");

const isSsr = container?.hasChildNodes();
const apiBaseUrl = document.documentElement?.getAttribute("data-api");

// eslint-disable-next-line @typescript-eslint/no-floating-promises
(async () => {
  const initObject = await fetch(
    `${apiBaseUrl}/v1/spainitobject?v=2&path=${window.location.pathname}${window.location.search.replace("?", "&")}`,
  ).then<SpaInitObject>((response) => {
    return response.json();
  });

  const Root = (
    <SettingsProvider settings={initObject.settings}>
      <BrowserRouter>
        <TanStackProvider staleTime={30000}>
          <Suspense fallback={""}>
            <App initialPageData={initObject.initialPageData} />
          </Suspense>
        </TanStackProvider>
      </BrowserRouter>
    </SettingsProvider>
  );
  if (isSsr) {
    hydrateRoot(container!, Root);
  } else {
    createRoot(container!).render(Root);
  }
})();
